<div class="policy_container">
    <h1>{{policy_name}}</h1>
  
     <div [innerHtml]="template"></div>
  </div>
  